import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

export default function Login() {
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const res = await fetch(`${API_URL}/login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario, password })
      });

      const data = await res.json();

      if (res.ok && data.token) {
        localStorage.setItem("token", data.token);
        navigate("/citas");
      } else {
        setError(data.mensaje || "No pudimos validar tus datos. Revisa usuario y contrasena.");
      }
    } catch (err) {
      setError("No hay conexion con el servidor. Intenta nuevamente en unos minutos.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-shell" aria-label="Acceso a la agenda terapeutica">
        <div className="login-hero">
          <div className="login-brand">
            <span className="login-brand-mark">A</span>
            <div>
              <p>Agenda Terapeutica</p>
              <span>Terapia de lenguaje</span>
            </div>
          </div>

          <div className="speech-scene" aria-hidden="true">
            <div className="speech-card speech-card-primary">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="speech-card speech-card-secondary">
              <span></span>
              <span></span>
            </div>
            <div className="progress-book">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>

          <div className="login-copy">
            <h1>Un espacio claro para acompanar cada avance.</h1>
            <p>
              Gestiona sesiones, pacientes y seguimiento terapeutico desde una agenda pensada
              para profesionales de comunicacion y lenguaje.
            </p>
          </div>

          <div className="login-points" aria-label="Beneficios">
            <span>Sesiones organizadas</span>
            <span>Seguimiento cercano</span>
            <span>Atencion profesional</span>
          </div>
        </div>

        <div className="login-panel">
          <div className="login-panel-header">
            <p>Bienvenido/a</p>
            <h2>Iniciar sesion</h2>
            <span>Ingresa para continuar con tu agenda de terapia.</span>
          </div>

          {error && <div className="login-alert">{error}</div>}

          <form onSubmit={handleLogin} className="login-form">
            <div className="login-field">
              <label htmlFor="usuario">Usuario</label>
              <input
                id="usuario"
                type="text"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                placeholder="Nombre de usuario"
                autoComplete="username"
                required
              />
            </div>

            <div className="login-field">
              <label htmlFor="password">Contrasena</label>
              <div className="password-control">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Tu contrasena"
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((current) => !current)}
                  aria-label={showPassword ? "Ocultar contrasena" : "Mostrar contrasena"}
                >
                  {showPassword ? "Ocultar" : "Ver"}
                </button>
              </div>
            </div>

            <button type="submit" className="login-submit" disabled={isLoading}>
              {isLoading ? "Ingresando..." : "Ingresar a mi agenda"}
            </button>
          </form>

          <p className="login-note">Acceso exclusivo para el equipo terapeutico.</p>
          <p className="login-note">
            <Link className="login-link" to="/olvide-password">Olvide mi contrasena</Link>
          </p>
        </div>
      </section>
    </main>
  );
}
